import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../request/request";

export const getUsersReportDetails = createAsyncThunk(
  "usersGraphDetails",
  async (object, { rejectWithValue }) => {
    const { tenantId, type, start, end} = object;
    let url = `/api/v1/tenant-users-report-details/${tenantId}?type=${type}&start=${start}&end=${end}`;
    const response = await request(url, { method: "GET", auth: true });
    if (response?.data) {
      return response;
    }
    const { error } = response;
    throw rejectWithValue(error || "Something went wrong");
  }
);
